import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { Customer } from 'src/app/models';
import { EditSalesDocketSettingsComponent } from '../../sale-docket/sale-docket-settings/edit-sales-docket-settings/edit-sales-docket-settings.component';
import { CustomerService } from '../../shared';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { FormsModule, NgModel } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-edit-customer-alert-dialog',
  template: ` <h1 mat-dialog-title>Edit Customer Alert</h1>
    <div mat-dialog-content class="flex flex-col items-stretch">
      <mat-form-field class="w-full">
        <mat-label>Alert Message</mat-label>
        <textarea
          matInput
          matTextareaAutosize
          placeholder="Alert Message"
          [(ngModel)]="data.popup_message"
          name="popup_message"
        ></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-flat-button mat-dialog-close>Close</button>
      <button mat-flat-button color="primary" (click)="save()">Save</button>
    </div>`,
  standalone: true,
  imports: [
    MatFormField,
    FormsModule,
    MatLabel,
    MatInput,
    MatDialogModule,
    MatButtonModule
  ]
})
export class EditCustomerAlertDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Customer,
    private dialog: MatDialogRef<EditSalesDocketSettingsComponent>,
    private customerService: CustomerService
  ) {}

  save() {
    const popup_message =
      this.data.popup_message.trim() !== ''
        ? this.data.popup_message.trim()
        : null;
    this.customerService
      .updateCustomer({
        popup_message,
        id: this.data.id
      } as any)
      .subscribe(() => {
        this.dialog.close();
      });
  }
}
